import { useTranslation } from "react-i18next";

import type { Profile } from "@/api/bale.zod";

import { useGetProfile } from "@/api/bale";
import { Badge } from "@/components/Badge";
import { ProfileItem } from "@/components/ProfileItem";
import { useCurrentEventSuspense } from "@/pages/EventPage/hooks/useCurrentEvent";

export type EventParticipantStyle = "name-only" | "full" | "avatar-only";

export function EventParticipant({ profile, style }: { profile: Profile; style: EventParticipantStyle }) {
  const { t } = useTranslation();
  const event = useCurrentEventSuspense({ query: { select: (data) => data.data.event } });
  const me = useGetProfile("@me", { query: { select: (data) => data.data.profile } });

  return (
    <div className="flex flex-row items-center gap-4" key={profile.id}>
      <ProfileItem
        hideAvatar={style === "name-only"}
        hideName={style === "avatar-only"}
        hideId={style === "name-only"}
        profile={profile}
      />
      {style !== "avatar-only" && (
        <div className="flex flex-row items-center gap-2">
          {me.isSuccess && profile.id === me.data.id && <Badge>{t("you")}</Badge>}
          {profile.id === event.data.account_id && <Badge>{t("host")}</Badge>}
        </div>
      )}
    </div>
  );
}
